import React from 'react';
import backgroundImage from '../assets/images/background_001.jpg';
import PageContainer from '../components/layout/PageContainer';

/**
 * SPLICEWebサイトトップページコンポーネント
 * 既存デザインを完全再現
 */
const IndexPage: React.FC = () => {
  return (
    <PageContainer pageType="background-image">
      <div className="position-relative overflow-hidden min-vh-100 d-flex flex-column"
           style={{
             backgroundImage: `url(${backgroundImage})`,
             backgroundSize: 'cover',
             backgroundPosition: 'center',
             backgroundRepeat: 'no-repeat',
             paddingTop: '120px'
           }}>
        <div className="text-white px-5 position-relative" style={{ zIndex: 2, maxWidth: '900px' }}>
          <h2 className="m-0 zen-old-mincho-bold">株式会社 SPLICE建築企画</h2>
          <p className="fs-4 my-5 zen-old-mincho-medium">〜 We are behind you.〜</p>
          <div className="d-flex justify-content-center">
            <div className="text-start m-0">
              <p className="fs-4 m-0 zen-old-mincho-medium">Splice & partners</p>
              <p className="zen-old-mincho-regular">
                建築設計を主軸とし、多種多様なパートナーと共に建築・不動産サービスの新しいカタチをご提供します。
              </p>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default IndexPage; 